import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from '../../environments/environment';
import { Respuesta } from '../entities/respuesta.entity';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { UploadFileComponent } from './Components/uploadfile.component';

export interface FormModel { captcha?: string; }

@Component({
  selector: 'app-encuestas',
  templateUrl: './encuestas.component.html'
})
export class EncuestasComponent implements OnInit {
  data = [
    {
      titulo : 'SOLICITUD DE ENCUESTA',
      descripcion : 'Rellena una pequeña encuesta para ayudarnos a mejorar.'
    }
  ];
  public formModel: FormModel = {};
  public keyCaptchaSite: string;
  public captchaError: boolean;
  public files: any[] = [];
  public name: string;
  public dni: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  @ViewChildren(UploadFileComponent) childs: QueryList<UploadFileComponent>;

  constructor( private sessionService: SessionService, private userService: UserService ) { }

  ngOnInit() {
    this.keyCaptchaSite = environment.capchasiteKey;
  }

  downloadFile(solId: number) {
    const link = document.createElement('a');
    switch (solId) {
      case 0:
        link.download = 'ENCUESTA';
        link.href = 'assets/documents/ENCUESTA.pdf';
      break;
    }
    link.click();
  }

  public enviarDocumento() {
    this.clearInputErrors();
    const formData: FormData = new FormData();
    this.files = this.sessionService.files;
    if (this.files.length > 0) {
      for (let j = 0; j < this.files.length; j++) {
        formData.append('procedure', this.files[j], this.files[j].name);
      }
    }
    if (this.formModel.captcha === undefined) {
      this.captchaError = this.formModel.captcha === undefined ? true : false;
    }
    if (this.files.length > 0 && this.formModel.captcha !== undefined) {
      formData.append('Nombre', this.sessionService.nombre);
      formData.append('Nif', this.sessionService.login);
      formData.append('EMail', this.sessionService.email);
      formData.append('Telefono', this.sessionService.telefono);
      formData.append('Contrato', this.sessionService.contratoSelected.Codigo.toString());
      formData.append('Direccion', this.sessionService.contratoSelected.InmuebleBO.Direccion);
      formData.append('ModoTest', this.sessionService.usuario.ModoTest === undefined ? false.toString() :
        this.sessionService.usuario.ModoTest.toString());
      formData.append('gRecaptchaResponse', this.formModel.captcha);
      formData.append('TipoDoc', 'encuesta');
      this.userService.uploadSolicitud(this.sessionService.explotacion, formData).subscribe(
        response => this.uploadOnSuccess(response),
        response => this.uploadOnError(response)
      );
      this.closeModal();
    } else if (this.files.length === 0) {
      this.childs.forEach(c => c.errors.push('Debe seleccionar el PDF de la encuesta'));
    }
  }

  public uploadOnSuccess(response: Respuesta) {
    this.messageCabecera = 'Encuesta enviada';
    this.messageComplet = 'La encuesta se ha enviado correctamente';
    this.typeException = 2;
  }

  public uploadOnError(response: Respuesta) {
    this.resultado = response;
    this.formModel.captcha = null;
    this.messageCabecera = 'Error en el envío';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error en el envío de la encuesta';
      this.typeException = 1;
    }
  }

  public clearInputErrors() {
    this.captchaError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
    this.childs.forEach(c => c.errors = []);
  }

  closeModal() {
    this.files = [];
    this.sessionService.files = [];
    grecaptcha.reset();
    this.childs.forEach(c => {
      c.reset();
      c.errors = [];
    });
    ($('#modal-subida') as any).modal('hide');
    this.captchaError = false;
    this.formModel.captcha = undefined;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/encuestas.component.ts